import React from "react";
import "./CandLogin.css";
import logo from "../../../assets/images/hire_form_logo.png";
import Navbar from "../../navbar/Navbar";
import Footer from "../../footer/Footer";
import { useCandidateLoginMutation } from "../../../slice/authApiSlice";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { setCredentials } from "../../../slice/authSlice";
import { useNavigate } from "react-router-dom";
import CandRegister from "../../register/candidate/CandRegister";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import MobileCandidateReg from "../../register/candidate/mcandidate/MobileCandidateReg";
import Forgot from "../forgot/Forgot";

const CandLogin = ({ onClose, onSubmit }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [login, { isLoading }] = useCandidateLoginMutation();
  const [candModalOpen, setCandModalOpen] = useState(false);
  const [forgotOpen, setForgotOpen] = useState(false);




  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };


  const loginHandler = async () => {
    const payload = {
      email,
      password,
    };
    if(email === ""){
      toast.error("Email is required");
    }else if(!validateEmail(email)){
      toast.error("Invalid email format");
    }else if(password === ""){
      toast.error("Password is required")
    }else{
      try {
        const res = await login(payload).unwrap();
        // console.log(res);
        
        dispatch(setCredentials({ 
          userInfo: res.user, 
          token: res.token 
        }));
        navigate("/");
      } catch (error) {
        toast.error(error?.data?.message || error);
      }
    }
 
  };

  const handleCandModalClick = () => {
    setCandModalOpen(!candModalOpen);
  };

  const handleForgotClick = () => {
    setForgotOpen(!forgotOpen);
  };

  return (
    <div className="cand_login_section">
      {candModalOpen && (
        <CandRegister
          onClose={handleCandModalClick}
          onSubmit={handleCandModalClick}
        />
      )}
         {forgotOpen && (
        <Forgot
          onClose={handleForgotClick}
          onSubmit={handleForgotClick}
        />
      )}
      {/* <Navbar /> */}
      <div className="cand_login_container ">
        <div className="cand_login_left_side">
          <div className="cand_login_heading_section">
            <div className="logo_img_container">
              <img src={logo} alt="logo" />
            </div>
            <div className="cand_login_heading_container">
              <h2>Explore 5 lakh+ career opportunities.</h2>
            </div>
          </div>
          <div className="pnt_container">
            <p>Privacy Policy</p>
            <p>Terms & Conditions</p>
          </div>
        </div>
        <div className="cand_login_right_side">
          <div className="close_button_container">
            <button>
              <FontAwesomeIcon
                icon={faXmark}
                className="cross_icon"
                onClick={() => onClose()}
              />
            </button>
          </div>
          <div className="rightside_heading_and_form_container">
            <h2>Welcome, glad to see you!</h2>
            <div className="cand_login_right_side_form_container">
              <form className="cand_login_right_side_form">
                <div className="cand_login_right_side_form_input_container">
                  <label>Candidate Email id</label>
                  <input
                    type="email"
                    placeholder="email"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                  />
                </div>
                <div className="cand_login_right_side_form_input_container">
                  <label>Password</label>
                  <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                    }}
                  />
                </div>
                <div className="f_password_section">
                  <a onClick={handleForgotClick}>Forgot Password?</a>
                </div>
              </form>
            </div>
            <div className="cand_login_button_container">
              <button onClick={loginHandler}>Login</button>
              <a>Login using OTP</a>
            </div>
          </div>
          <div className="create_account_section">
            <p>Don’t have an account?</p>
            <a onClick={handleCandModalClick}>
              <button>Create an Account</button>
            </a>
          </div>
        </div>
      </div>
      {/* <Footer className="footer" /> */}
    </div>
  );
};

export default CandLogin;
